import React, { createRef } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import SignPage from './pages/sign/SignPage';
import RecoveryPage from './pages/recovery/RecoveryPage';

import useResize from '../../hooks/useResize';
import { computeScale } from '../../utils/device';

import styles from './AuthPage.module.scss';

const bgN = Math.floor(Math.random() * 4);

export default observer(function AuthPage() {
    const backgroundRef = createRef<HTMLDivElement>();

    useResize(() => {
        const scale = computeScale();

        if (backgroundRef.current) {
            backgroundRef.current.style.width = `${100 / scale}vw`;
            backgroundRef.current.style.height = `${100 / scale}vh`;
        }
    }, [backgroundRef]);

    return (
        <div className={styles.container}>
            <div
                className={classNames(styles.background, {
                    [styles.bg1]: bgN === 0,
                    [styles.bg2]: bgN === 1,
                    [styles.bg3]: bgN === 2,
                    [styles.bg4]: bgN === 3,
                })}
                ref={backgroundRef}
            />

            <Switch>
                <Route exact path="/auth/login"><SignPage page="login"/></Route>
                <Route exact path="/auth/signup"><SignPage page="signup"/></Route>
                <Route exact path="/auth/recovery"><RecoveryPage/></Route>
                <Route path="/auth"><Redirect to="/auth/login"/></Route>
            </Switch>
        </div>
    );
});
